import { ActionTree } from 'vuex'
import client from 'axios'
import { ReportsState } from '@/store/modules/report/types'
import { ReportMutations } from '@/store/modules/report/mutations'
import _ from 'lodash'
import { apiEndpoints } from '@/constants/api/api'

export enum ReportsActions {
  FETCH_REPORTS = 'FETCH_REPORTS',
  GET_SUBSCRIBER_REPORT = 'GET_SUBSCRIBER_REPORT'
}

export const actions: ActionTree<ReportsState, any> = {
  [ReportsActions.FETCH_REPORTS]: async (context, payload) => {
    context.commit(ReportMutations.TRIGGER_LOADING, true)
    if (!payload || _.isEmpty(payload)) return

    try {
      const { data } = await client({
        method: apiEndpoints.reports.fetchReports.method,
        url: apiEndpoints.reports.fetchReports.url,
        params: { customer_id: payload.customerId }
      })
      context.commit(ReportMutations.SET_REPORTS, data.data)
      context.commit(ReportMutations.SET_INITIAL_REPORT, data.data[0])
    } catch (error) {
      throw new Error(JSON.stringify(error))
    } finally {
      context.commit(ReportMutations.TRIGGER_LOADING, false)
    }
  },
  [ReportsActions.GET_SUBSCRIBER_REPORT]: async (context, params) => {
    context.commit(ReportMutations.TRIGGER_LOADING, true)
    context.commit('setIndex', 0)
    await client({
      method: apiEndpoints.reports.getSubscriberReport.method,
      url: apiEndpoints.reports.getSubscriberReport.url,
      params: params
    })
      .then(resp => {
        context.commit(ReportMutations.TRIGGER_LOADING, false)
        if (
          resp?.data?.data &&
          resp?.data?.info &&
          resp?.data?.info?.message === 'success'
        ) {
          context.commit(ReportMutations.SET_SUBSCRIBER_REPORTS, resp.data.data)
        }
      })
      .catch(err => {
        context.commit(ReportMutations.TRIGGER_LOADING, false)
        throw new Error(err)
      })
  },
  fetch: async (context, payload) => {
    context.commit('setCustomerId', payload)
    context.dispatch(ReportsActions.FETCH_REPORTS, { customerId: payload })
  },
  changeIndex: (context, payload = 0) => {
    context.commit('setIndex', payload)
  },
  searchCustomers: async (context, payload) => {
    context.commit(ReportMutations.TRIGGER_LOADING, true)
    try {
      const res = await client({
        method: 'GET',
        url: '/report/search',
        params: {
          keywords: _.isString(payload) ? payload : payload.key
        }
      })

      context.commit(ReportMutations.TRIGGER_LOADING, false)

      return _.get(res, 'data.data')
    } catch (error) {
      throw new Error(JSON.stringify(error))
    } finally {
      context.commit(ReportMutations.TRIGGER_LOADING, false)
    }
  }
}
